export default __webpack_public_path__ + "5011d1fa8be1ed68f3dbd56b6fac1228.svg";